import React, { useEffect } from "react";
import {
  Button,
  Col,
  PopoverBody,
  PopoverHeader,
  Spinner,
  TabPane,
  UncontrolledPopover,
} from "reactstrap";
import { useDispatch } from "react-redux";
import AddEmployeesModal from "../../../../Components/modals/EmployeesModal/AddEmployee/AddEmployeesModal";
import Loading from "../../../../Components/Loading";
import moment from "moment";
import { formatInvoiceDueDateFromEffectiveDate } from "../../../../utils/utils";
import NextButton from "../../components/NextButton";

const EmployerEmployeesStep = ({
  loadingUpdate,
  employerEmployeesStep,
  activeVerticalTab,
  setEmployees,
  employees,
  onRefreshTable,
  onFinishOnboarding,
  toggleVerticalTab,
  loading,
  setLoading,
  coverageEffectiveDate,
}) => {
  const dispatch = useDispatch();

  const [openModalAddEmployee, setOpenModalAddEmploye] = React.useState(false);

  // Show message if  today is between the 15th of the month and the 25th of the month.
  const isTodayBetween15thAnd25th =
    moment().date() >= 15 && moment().date() <= 25;
  const showPayCoverageImportantMessage = isTodayBetween15thAnd25th;
  const prevMonthCoverageDate = formatInvoiceDueDateFromEffectiveDate(
    coverageEffectiveDate
  );

  const handleSubmit = async () => {
    toggleVerticalTab(activeVerticalTab + 1);
  };

  useEffect(() => {
    if (activeVerticalTab === 9) {
      onRefreshTable();
    }
  }, [activeVerticalTab]);

  const handleModalAddEmployee = () => {
    setOpenModalAddEmploye(true);
  };

  return (
    <TabPane tabId={employerEmployeesStep}>
      <AddEmployeesModal
        open={openModalAddEmployee}
        setOpen={setOpenModalAddEmploye}
        onCreate={onRefreshTable}
        setEmployees={setEmployees}
        setLoading={setLoading}
      />
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex flex-column">
          <h5>Employee Details</h5>
          <p className="text-muted">
            Almost done! Enter your employees that you want covered and coverage
            effective date.
          </p>
        </div>
        <div className="d-flex justify-content-end my-3">
          <Button
            onClick={handleModalAddEmployee}
            color="soft-primary"
            size="md"
            className="py-0 border-primary d-flex align-items-center"
          >
            Add Employee <i className="mdi mdi-plus fs-3 p-0"></i>
          </Button>
        </div>
      </div>
      <div className="table-container position-relative mb-5">
        {" "}
        <div className={`table-responsive ${loading ? "" : ""}`}>
          <table className="table table-hover">
            <thead className="bg" style={{ background: "var(--thead-bg)" }}>
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            {loading && <Loading />}
            <tbody>
              {employees.length === 0 && !loading && (
                <tr>
                  <td colSpan="3" className="text-center">
                    Add your first employee!
                  </td>
                </tr>
              )}
              {employees.map((employee) => (
                <tr key={employee.id}>
                  <td>{employee.firstName}</td>
                  <td>{employee.lastName}</td>
                  <td>{employee.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex align-items-end justify-content-between gap-3 mt-4">
        <Col lg={4}>
          <h6 className="d-flex align-items-center mb-0">
            Coverage Effective Date
            {/* //  Info popover */}
            <i
              className="ri-information-line fs-18 ms-1 cursor-pointer"
              id="coverageEffectiveDateInfo"
            ></i>
            <UncontrolledPopover
              onClick={(e) => e.stopPropagation()}
              placement="right"
              target={`coverageEffectiveDateInfo`}
              trigger="hover"
            >
              <PopoverHeader>Coverage Effective Date</PopoverHeader>
              <PopoverBody className="p-1">
                Date when the coverage will start for your employees.
              </PopoverBody>
            </UncontrolledPopover>
          </h6>
          <div>
            {/* Just show coverage effective date */}
            <p>
              {moment(coverageEffectiveDate).utc().format("MMMM Do, YYYY")} (
              {
                // Days from now.
                moment(coverageEffectiveDate).diff(moment(), "days") + 1
              }{" "}
              days from now)
            </p>

            {showPayCoverageImportantMessage && (
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="text-danger"
              >
                <i className="ri-information-line fs-18 ms-1 cursor-pointer"></i>
                <span className="ms-1">
                  You have until the 20th of {prevMonthCoverageDate} to add
                  employees. This will be your first billing date in which you
                  will automatically be charged for employees that have been
                  added. No action is needed.
                </span>
              </p>
            )}
          </div>
        </Col>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-soft-primary border border-primary d-flex align-items-center justify-content-center text-center py-0 me-2 "
            onClick={() => {
              handleSubmit();
            }}
            disabled={loadingUpdate}
            style={{ width: "200px" }}
          >
            {loadingUpdate ? (
              <Spinner size="sm" className="me-2">
                {" "}
                Loading...{" "}
              </Spinner>
            ) : null}
            Skip for now
            <i className="ri-arrow-right-line align-middle fs-16 ms-2"></i>{" "}
          </button>
          <NextButton
            type={"button"}
            next={handleSubmit}
            disabled={loadingUpdate}
            label={"Next"}
            loading={loading}
          />
          {/* <button
            type="button"
            className="btn btn-primary btn-label right nexttab ms-3"
            onClick={() => {
              handleSubmit();
            }}
            disabled={loadingUpdate}
          >
            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>{" "}
            {loadingUpdate ? (
              <Spinner size="sm" className="me-2">
                {" "}
                Loading...{" "}
              </Spinner>
            ) : null}
            Finish
          </button> */}
        </div>
      </div>
    </TabPane>
  );
};

export default EmployerEmployeesStep;
